import { Box, Typography, styled } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";

type Props = {
  readonly icon: React.ReactNode;
  readonly title: string;
  readonly subtitle: string;
  readonly cta?: React.ReactNode;
};

const StyledBackground = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 480px;
  height: 480px;
  background-image: url("/images/circular_pattern.png");
`;

const StyledContent = styled(Box)`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  left: -140px;
  top: 50px;
  width: 300px;
`;

export const AnalysesEmptyState: React.FC<Props> = ({ icon, title, subtitle, cta }) => {
  return (
    <Box
      sx={{
        height: 480,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <StyledBackground>
        <Box sx={{ height: 20, position: "relative" }}>
          {icon}
          <StyledContent>
            <Typography variant="body1" fontWeight="600">
              {title}
            </Typography>
            <Typography mt={Spacing.S} mb={Spacing.XL} variant="body2" color="secondary" fontWeight="400">
              {subtitle}
            </Typography>
            {cta && cta}
          </StyledContent>
        </Box>
      </StyledBackground>
    </Box>
  );
};
